<template>
  <div v-show="isContestAuthorized">
    <h4>
      Уважаемый(-ая), <b>{{ fullName }}</b>
    </h4>
    <p style="text-indent: 20px; text-align: justify; text-justify: inter-word;">
      В ходе тестирования Вам будут последовательно предъявлены вопросы.
      Каждый вопрос включает помимо формулировки несколько вариантов ответа.
      Вам необходимо выбрать правильный(-ые) вариант и отметить его с помощью левой клавиши мыши.
      После того, как Вы выбрали ответ, следует нажать кнопку «Вперед» в нижнем правом углу окна.
      Если Вы не знаете ответа на предъявленный вопрос, то нажмите кнопку «Пропустить».
      Если Вы прошли все вопросы, но некоторые из них остались без ответа,
      то система автоматически предъявит оставшиеся вопросы для повторной попытки ответа.
      Помните, что время на тестирование ограничено.
      После истечения отведенного времени, результаты Вашего тестирования будут автоматически сохранены в базе данных.
      Если Вы закончили тест раньше отведенного времени, то нажмите кнопку «Выход».
    </p>
    <br>
    <p>
      Вам предстоит пройти сценарий:
    </p>
    <p style="font-weight:bold">
      {{scenarioLabel}}
    </p>
    <span v-if="showDescription">
      <p>
        Описание сценария:
      </p>
      <p style="font-weight:bold">
        {{scenarioDescription}}
      </p>
    </span>
    <span v-if="scenarioContinued">
      <p>
        Сценарий не был завершен корректно и будет продолжен с места завершения.
      </p>
    </span>
  </div>
</template>

<script>
  import config from '../../appsettings.js'
  import { mapActions, mapGetters } from 'vuex'

  export default {
      name: 'scenariowelcome',
      data() {
        return {
          code : ''
        }
      },
      methods: {
        toState() {
          if(this.currentState) {
              const path = this.currentState.path;
              if(path) {
                this.code = '';
                this.$router.push(path);
              }
          }
        },
        tryInitializeContest() {
          ///EXAMPLE: localhost:8080/scenario-welcome?code='ABCDE'
          this.processLoad(true);
          let code = this.$route.query.code;
          let self = this;
          let prefix = config.API_PREFIX;
          this.$gf.getOptions().then(options => {
            options.params = {
            };
            self.$http.post(`${prefix}testing/next`, { stage: 0, userScenarioUid: (code ? code : null) }, options).then(response => {
              let scenario = response.data;
              if(scenario) {
                this.initializeScenario(scenario.data);
                this.nextState(scenario.stage);
                if(code) {
                  this.processShowPassed(false);
                }
                this.toState();
              } else {
                this.$router.push(config.WELCOME_URL);
                this.$alert('Вы уже прошли тестирование', 'Информация', {
                  confirmButtonText: 'OK',
                  type: 'info',
                  callback: action => {

                  }
                });
              }
              this.processLoad(false);
            }).catch(data => {
              this.processLoad(false);
              this.exit();
              self.$gf.checkError(data);
            });
          }).catch(err => {
            this.processLoad(false);
            this.exit();
            this.$gf.catchOptions();
            this.$router.push(config.WELCOME_URL);
          });
        },
        ...mapActions([
          'nextState',
          'initializeScenario',
          'exit',
          'processLoad',
          'processShowPassed'
        ])
      },
      computed: {
        fullName: function() {
            return this.scenarioUser;
        },
        showDescription: function() {
          if(this.scenarioDescription)
            return true;
          return false;
        },
        ...mapGetters([
          'scenarioLabel',
          'scenarioDescription',
          'scenarioContinued',
          'scenarioUser',
          'currentState',
          'isContestAuthorized'
        ])
      },
      created() {
        this.tryInitializeContest();
      }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/contest/scenariowelcome.vue